/**
 * Model used to hold a model along with an isSelected property
 * so it can be tracked when displaying in a checkbox list.
 *
 * Example: Features checkbox list on the basics component
 */
export class Selectable<T> {
    public model: T;
    public isSelected: boolean;
    public isEnabled: boolean;

    constructor(model: T, isSelected: boolean = false, isEnabled: boolean = true) {
        this.model = model;
        this.isSelected = isSelected;
        this.isEnabled = isEnabled;
    }
}
